// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"nm-z","badgeLink":"om-z","category":"pm-z"};